export default __webpack_public_path__ + "static/4-7e542b8f5ed5578d01d301bcdd69f54f.jpeg";